<template>
    <div class="flex gap-x-4 items-center font-bold text-white animate-fade-left">
        <a href="/EN" class="underline">EN</a>
        <p> / </p>
        <a href="/" class="underline">FR</a>
    </div>
</template>